/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RootRoutes {
  FORGOT_PW_ROUTE = '/login/redefinir-senha',
  INACTIVITY_ROUTE = '/inatividade',
  LOGIN_ROUTE = '/login',
  NEW_PW_ROUTE = '/nova-senha/:hash',
  PRIVACY_WARNING_ROUTE = '/aviso-de-privacidade/:nrSeqWarning',
  ROUTE_CHANGE_PW_USERNAME = '/login/renovar-senha/:nrSequence',
  ROUTE_CONF_USER_NEW_PW = '/confirmar-usuario/:hash/novo-usuario',
  ROUTE_HOME = '/credenciamento-prestador/:nrSeqUser',
  ROUTE_NEW_USER_CONFIRMATION = '/confirmar-usuario/:hash',
  ROUTE_REDIRECT = '/credenciamento-prestador',
  ROUTE_TERMS_OF_USE = '/termo-de-uso/:nrSeqTerm',
}
export { RootRoutes };
